import { render, staticRenderFns } from "./editReward.vue?vue&type=template&id=a267178e&scoped=true&"
import script from "./editReward.vue?vue&type=script&lang=js&"
export * from "./editReward.vue?vue&type=script&lang=js&"
import style0 from "./editReward.vue?vue&type=style&index=0&id=a267178e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267178e",
  null
  
)

export default component.exports